export const USER_LOGIN = {
    LOGIN_USERNAME_LABEL: {
        key: 'LOGIN_USERNAME_LABEL',
        value: 'Username'
    },
    LOGIN_USERNAME_PLACEHOLDER: {
        key: 'LOGIN_USERNAME_PLACEHOLDER',
        value: 'Enter your username'
    },
    INVALID_USER_EMAIL_ERROR_MESSAGE: {
        key: 'INVALID_USER_EMAIL_ERROR_MESSAGE',
        value: 'Invalid email address'
    },
    WRONG_CREDENTIAL_COMBINATION_ERROR_MESSAGE: {
        key: 'WRONG_CREDENTIAL_COMBINATION_ERROR_MESSAGE',
        value: 'Email password combination is incorrect.'
    },
    GENERAL_ERROR_MESSAGE: {
        key: 'GENERAL_ERROR_MESSAGE',
        value: 'Oops! Something went wrong.'
    },
    SOMETHING_WENT_WRONG_ERROR_MESSAGE: {
        key: 'SOMETHING_WENT_WRONG_ERROR_MESSAGE',
        value: 'Something went wrong.Please reload the page and try again.'
    },
    LOGIN_PASSWORD_LABEL: {
        key: 'LOGIN_PASSWORD_LABEL',
        value: 'Password'
    },
    LOGIN_PASSWORD_PLACEHOLDER: {
        key: 'LOGIN_PASSWORD_PLACEHOLDER',
        value: 'Enter your password'
    },
    FORGOT_PASSWORD_ACTION: {
        key: 'FORGOT_PASSWORD_ACTION',
        value: 'Forgot Password'
    },
    LOGGING_IN_USER_BUTTON: {
        key: 'LOGGING_IN_USER_BUTTON',
        value: 'LOGGING IN'
    },
    LOGIN_USER_BUTTON: {
        key: 'LOGIN_USER_BUTTON',
        value: 'LOG ME IN'
    },
    LOGIN_USER_DESCRIPTION: {
        key: 'LOGIN_USER_DESCRIPTION',
        value: 'Welcome Back! Enter your details to login'
    },
    REDIRECT_TO_CREATE_ACCOUNT_DESCRIPTION: {
        key: 'REDIRECT_TO_CREATE_ACCOUNT_DESCRIPTION',
        value: 'Need a Perfect Studio Account'
    },
    REDIRECT_TO_CREATE_ACCOUNT_ACTION: {
        key: 'REDIRECT_TO_CREATE_ACCOUNT_ACTION',
        value: 'Register'
    },
    EMAIL_NOT_EXIST_ERROR_MESSAGE: {
        key: 'EMAIL_NOT_EXIST_ERROR_MESSAGE',
        value: "Email doesn't exist"
    },
};

export const RESET_USER_PASSWORD = {
    RESET_PASSWORD_TITLE: {
        key: 'RESET_PASSWORD_TITLE',
        value: 'RESET PASSWORD'
    },
    RESET_PASSWORD_USERNAME_LABEL: {
        key: 'RESET_PASSWORD_USERNAME_LABEL',
        value: 'Username'
    },
    RESET_PASSWORD_USERNAME_PLACEHOLDER: {
        key: 'RESET_PASSWORD_USERNAME_PLACEHOLDER',
        value: 'Enter your username'
    },
    RESET_PASSWORD_DESC: {
        key: 'RESET_PASSWORD_DESC',
        value: 'To reset your password, Enter your username.'
    },
    BACK_TO_LOGIN_ACTION: {
        key: 'BACK_TO_LOGIN_ACTION',
        value: 'Back to Login'
    },
    SEND_RESET_PASSWORD_EMAIL_BUTTON: {
        key: 'SEND_RESET_PASSWORD_EMAIL_BUTTON',
        value: 'Submit'
    },
    ERROR_EMAIL_EXISTS: {
        key: 'ERROR_EMAIL_EXISTS',
        value: 'The email address already exists.'
    },
    RESET_PASSWORD_MAIL_CONFIRMATION_TITLE: {
        key: 'RESET_PASSWORD_MAIL_CONFIRMATION_TITLE',
        value: 'Check your Email'
    },
    RESET_PASSWORD_MAIL_CONFIRMATION_DESCRIPTION: {
        key: 'RESET_PASSWORD_MAIL_CONFIRMATION_DESCRIPTION',
        value: 'We have sent you an email with instructions on how to reset your password'
    },
    WAITING_FOR_EMAIL_VERIFICATION_ALT_TEXT: {
        key: 'WAITING_FOR_EMAIL_VERIFICATION_ALT_TEXT',
        value: 'Waiting for email verification'
    },
    BACK_TO_LOGIN_BUTTON: {
        key: 'BACK_TO_LOGIN_BUTTON',
        value: 'Back to Login'
    },
};

export const USER_AUTHENTICATION_PAGE = {
    CHANGE_USER_PASSWORD_TITLE: {
        key: 'CHANGE_USER_PASSWORD_TITLE',
        value: 'CHANGE YOUR PASSWORD'
    },
    GROW_WITH_US_VIDEO_TITLE: {
        key: 'GROW_WITH_US_VIDEO_TITLE',
        value: 'Grow with us!!'
    },
    STREAMLINE_MULTILINGUAL_COMMUNICATION_MESSAGE: {
        key: 'STREAMLINE_MULTILINGUAL_COMMUNICATION_MESSAGE',
        value: 'Streamline multilingual communication'
    },
    DELIGHT_CUSTOMER_WORLDWIDE_MESSAGE: {
        key: 'DELIGHT_CUSTOMER_WORLDWIDE_MESSAGE',
        value: 'delight customers worldwide'
    },
    PRODUCT_LANGUAGES_DESCRIPTION: {
        key: 'PRODUCT_LANGUAGES_DESCRIPTION',
        value: '100+ LANGUAGES'
    },
    PRODUCT_CHANNELS_USED_DESCRIPTION: {
        key: 'PRODUCT_CHANNELS_USED_DESCRIPTION',
        value: '5 CHANNELS'
    },
};

export const CREATE_ACCOUNT = {
    EMAIL_EXISTS_ERROR_MESSAGE: {
        key: 'EMAIL_EXISTS_ERROR_MESSAGE',
        value: 'The email address already exists.'
    },
    ACCEPT_TERMS_AND_CONDITIONS_ERROR_MESSAGE: {
        key: 'ACCEPT_TERMS_AND_CONDITIONS_ERROR_MESSAGE',
        value: 'Please accept the terms and conditions.'
    },
    GENERAL_ERROR_MESSAGE: {
        key: 'GENERAL_ERROR_MESSAGE',
        value: 'Oops! Something went wrong.'
    },
    CREATE_ACCOUNT_TITLE: {
        key: 'CREATE_ACCOUNT_TITLE',
        value: 'CREATE YOUR ACCOUNT'
    },
    CREATE_ACCOUNT_DESCRIPTION: {
        key: 'CREATE_ACCOUNT_DESCRIPTION',
        value: 'Enter your Business Email address below and complete some easy steps to register your account'
    },
    CREATE_ACCOUNT_EMAIL_PLACEHOLDER: {
        key: 'CREATE_ACCOUNT_EMAIL_PLACEHOLDER',
        value: 'example@domain.com'
    },
    INVALID_EMAIL_ERROR_MESSAGE: {
        key: 'INVALID_EMAIL_ERROR_MESSAGE',
        value: 'Invalid email address'
    },
    CONFIRM_PASSWORD_PLACEHOLDER: {
        key: 'CONFIRM_PASSWORD_PLACEHOLDER',
        value: 'Confirm password'
    },
    PASSWORD_MISMATCH_ERROR_MESSAGE: {
        key: 'PASSWORD_MISMATCH_ERROR_MESSAGE',
        value: 'Password does not match!'
    },
    TERMS_AND_CONDITIONS_LABEL: {
        key: 'TERMS_AND_CONDITIONS_LABEL',
        value: 'I agree with the terms and conditions',
    },
    TERMS_AND_CONDITIONS_LINK_TEXT: {
        key: 'TERMS_AND_CONDITIONS_LINK_TEXT',
        value: 'User Agreement and Privacy policy',
    },
    CREATE_ACCOUNT_BUTTON: {
        key: 'CREATE_ACCOUNT_BUTTON',
        value: "LET'S START "
    },
    ALREADY_HAVE_ACCOUNT_DESCRIPTION: {
        key: 'ALREADY_HAVE_ACCOUNT_DESCRIPTION',
        value: 'Already have an account'
    },
    REDIRECT_TO_USER_LOGIN_ACTION: {
        key: 'REDIRECT_TO_USER_LOGIN_ACTION',
        value: 'Login'
    },
    WEAK_PASSWORD_ERROR_MESSAGE: {
        key: 'WEAK_PASSWORD_ERROR_MESSAGE',
        value: "Your password is not strong enough. Please choose a password that is not ordinary to ensure the security of your account"
    },
    PDF_DOWNLOAD_PRICE_INFO: {
        key: 'PDF_DOWNLOAD_PRICE_INFO',
        value: 'Download your PDF directly by making a payment of ${{price}}. You will also receive an email with your PDF attached.'
    },
    PAY_DOWNLOAD_BUTTON_TEXT: {
        key: 'PAY_DOWNLOAD_BUTTON_TEXT',
        value: 'Pay ${{price}} & Download'
    },
};

export const SET_USER_PASSWORD = {
    PASSWORD_RESET_FAILED_ERROR_MESSAGE: {
        key: 'PASSWORD_RESET_FAILED_ERROR_MESSAGE',
        value: 'Password reset failed. Please try again'
    },
    GENERAL_ERROR_MESSAGE: {
        key: 'GENERAL_ERROR_MESSAGE',
        value: 'Oops! Something went wrong.'
    },
    SET_PASSWORD_LABEL: {
        key: 'SET_PASSWORD_LABEL',
        value: 'Password'
    },
    SET_CONFIRM_PASSWORD_LABEL: {
        key: 'SET_CONFIRM_PASSWORD_LABEL',
        value: 'Confirm password'
    },
    SET_CONFIRM_PASSWORD_PLACEHOLDER: {
        key: 'SET_CONFIRM_PASSWORD_PLACEHOLDER',
        value: 'Confirm password'
    },
    PASSWORD_MISMATCH_ERROR_MESSAGE: {
        key: 'PASSWORD_MISMATCH_ERROR_MESSAGE',
        value: 'Password does not match!'
    },
    RESET_PASSWORD_BUTTON: {
        key: 'RESET_PASSWORD_BUTTON',
        value: 'Submit'
    },
    CHECK_PASSWORD_MESSAGE: {
        key: 'CHECK_PASSWORD_MESSAGE',
        value: "Your password is not strong enough. Please choose a password that is not ordinary to ensure the security of your account"

    },
    PASSWORD_SET_MSG: {
        key: 'PASSWORD_SET_MSG',
        value: 'Password has been set successfully!'
    },
}; 
    
export const ORGANIZATION_SETUP = {
    ORGANIZATION_CREATED_SUCCESS_MESSAGE: {
        key: 'ORGANIZATION_CREATED_SUCCESS_MESSAGE',
        value: 'Organization setup completed successfully. Please proceed to sign in.',
    },
    ORGANIZATION_CREATION_ERROR_MESSAGE: {
        key: 'ORGANIZATION_CREATION_ERROR_MESSAGE',
        value: 'Failed to set up the organization.',
    },
    PHONE_NUMBER_INVALID_ERROR_MESSAGE: {
        key: 'PHONE_NUMBER_INVALID_ERROR_MESSAGE',
        value: 'Please provide a valid phone number.',
    },
    EMAIL_INVALID_ERROR_MESSAGE: {
        key: 'EMAIL_INVALID_ERROR_MESSAGE',
        value: 'Please enter a valid email address.',
    },
    ALL_FIELDS_REQUIRED_ERROR_MESSAGE: {
        key: 'ALL_FIELDS_REQUIRED_ERROR_MESSAGE',
        value: 'All required fields must be filled out.',
    },
    SETUP_ORGANIZATION_TITLE: {
        key: 'SETUP_ORGANIZATION_TITLE',
        value: 'Set up this organization',
    },
    ORGANIZATION_NAME_LABEL: {
        key: 'ORGANIZATION_NAME_LABEL',
        value: 'Organization Name',
    },
    PHONE_NUMBER_LABEL: {
        key: 'PHONE_NUMBER_LABEL',
        value: 'Phone Number',
    },
    CONTACT_PERSON_FIRST_NAME_LABEL: {
        key: 'CONTACT_PERSON_FIRST_NAME_LABEL',
        value: 'Contact Person First Name',
    },
    CONTACT_PERSON_LAST_NAME_LABEL: {
        key: 'CONTACT_PERSON_LAST_NAME_LABEL',
        value: 'Contact Person Last Name',
    },
    CONTACT_PERSON_EMAIL_LABEL: {
        key: 'CONTACT_PERSON_EMAIL_LABEL',
        value: 'Contact Person Email',
    },
    COUNTRY_LABEL: {
        key: 'COUNTRY_LABEL',
        value: 'Country',
    },
    STATE_LABEL: {
        key: 'STATE_LABEL',
        value: 'State',
    },
    CITY_LABEL: {
        key: 'CITY_LABEL',
        value: 'City',
    },
    ZIP_CODE_LABEL: {
        key: 'ZIP_CODE_LABEL',
        value: 'Zip Code',
    },
    ADDRESS_LINE_LABEL: {
        key: 'ADDRESS_LINE_LABEL',
        value: 'Address Line',
    },
    ACTIVATION_KEY_LABEL: {
        key: 'ACTIVATION_KEY_LABEL',
        value: 'Activation Key',
    },
    ACTIVATE_ORGANIZATION_BUTTON: {
        key: 'ACTIVATE_ORGANIZATION_BUTTON',
        value: 'Activate Organization',
    },
    ACTIVATING_ORGANIZATION_BUTTON: {
        key: 'ACTIVATING_ORGANIZATION_BUTTON',
        value: 'Activating Organization',
    },
}

export const LICENSE_EXPIRED_PAGE = {
    LICENSE_EXPIRED_TITLE: {
        key: 'LICENSE_EXPIRED_TITLE',
        value: 'License Expired',
    },
    LICENSE_EXPIRED_DESCRIPTION: {
        key: 'LICENSE_EXPIRED_DESCRIPTION',
        value: 'Your license has expired, please reach out to our support team to initiate the renewal process.',
    }
}

export const ENTERPRISE = {
    LICENSE_API_FAILED_ERROR_MESSAGE: {
        key: 'LICENSE_API_FAILED_ERROR_MESSAGE',
        value: 'License details could not be retrieved.',
    },
    ORGANIZATION_API_FAILED_ERROR_MESSAGE: {
        key: 'ORGANIZATION_API_FAILED_ERROR_MESSAGE',
        value: 'Organization details could not be retrieved.',
    }
}